<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path id="message-triangle" d="M11.546 14.3428L1.18584 3.37325C-0.0187652 2.09778 0.885474 0 2.63987 0H13C14.1046 0 15 0.89543 15 2V12.9695C15 14.779 12.7884 15.6583 11.546 14.3428Z" fill="currentColor"/>
</svg>
